import { FC, ReactNode } from 'react';
import { AIIcon, IconComponent } from '../../theme/Icons';
import { Text } from '../../components/Text';

export const BulletList: React.FC<{ heading: string, items?: string[], as?: React.ElementType }> = ({ heading, items, as: Wrapper = 'div' }) => {
    if (items?.length && Array.isArray(items)) {
        return (
            <Wrapper style={{marginBottom: 12}}>
                <b>{heading}</b>
                <ul style={{margin: 0}}>
                    {items!.map((item, idx) => (<li key={`item-${idx}`}>{item}</li>))}
                </ul>
            </Wrapper>
        );
    }
};

export type IViewNoteHeadingProps = {
    title: string;
    Icon: IconComponent;
    showAIIcon?: boolean;
};

const ViewNoteHeading: FC<IViewNoteHeadingProps> = ({ title, Icon, showAIIcon }) => {
    return (
        <div style={{display: 'flex', gap: 6, marginBottom: 8}}>
            <Icon color="medium" />
            <Text type="subtitle"><span style={{color: 'var(--ion-color-step-600)'}}>{title}</span></Text>
            {showAIIcon && <AIIcon color="primary" />}
        </div>
    );
};

export const ViewNoteSection: FC<IViewNoteHeadingProps & { children: ReactNode; }> = ({ title, Icon, children, showAIIcon }) => {
    return (
        <div style={{marginTop: 12, marginBottom: 16}}>
            <ViewNoteHeading title={title} Icon={Icon} showAIIcon={showAIIcon} />
            {children}
        </div>
    );
};
